import { getDefaultHeaders, setCsrfToken } from "./utils";

export async function submitJobPost(stage, file_id) {
  let headers = await getDefaultHeaders(true, true);
  const requestOptions = {
    method: "POST",
    headers: headers,
  };
  const url = `/api/submit-job/${stage}/${file_id}/`;
  try {
    const response = await fetch(url, requestOptions);
    const jsonResponse = await response.json();
    if (response.status === 403 && jsonResponse.detail.includes("CSRF Failed")) {

      await setCsrfToken();
      return await submitJobPost(stage, file_id)
    }
    return jsonResponse;
  } catch (err) {
    console.log("ERROR 17", err);
    return [];
  }
}

export async function retryTranslationPost(file_id, language_codes) {
  const headers = await getDefaultHeaders(true, true);
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: language_codes ? JSON.stringify({ language_codes }) : undefined,
  };
  const url = `/api/retry-translation/${file_id}/`;
  try {
    const response = await fetch(url, requestOptions);
    const jsonResponse = await response.json();
    if (response.status === 403 && jsonResponse.detail && jsonResponse.detail.includes("CSRF Failed")) {
      await setCsrfToken();
      return await retryTranslationPost(file_id, language_codes);
    }
    if (!response.ok) {
      throw new Error(jsonResponse?.error || "Retry failed");
    }
    return jsonResponse;
  } catch (err) {
    console.log("ERROR retry-translation", err);
    throw err;
  }
}
